import { type SVGProps } from "react";

export const InfoWarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
    viewBox="0 0 16 16">
    <path
      fill={props.fill || "#DC2626"}
      d="M8 1.5A6.5 6.5 0 1 0 14.5 8 6.507 6.507 0 0 0 8 1.5ZM7.5 5a.5.5 0 1 1 1 0v3.5a.5.5 0 1 1-1 0V5Zm.5 6.5A.75.75 0 1 1 8 10a.75.75 0 0 1 0 1.5Z"
    />
  </svg>
);
